



import Page from '../PostSales/sale/PostSaleList.vue'
export default {
  name: 'postsalelistODM',
  components: { Page },
}
